import {
  FETCH_SITES_SUCCESS,
  RESET_SITE_SEARCH,
  SHOW_RESULTS,
} from './constants';

const initialState = {
  data: [],
  totalCount: null,
  pageSize: 7,
  showResults: false,
  isSitesFetched: false,
  mapZoom: 1,
  location: {
    lat: 0,
    lng: 0,
  },
};

function siteSearchReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_SITES_SUCCESS: {
      const { data = [] } = action;
      return {
        ...state,
        totalCount: data.length,
        data,
        isSitesFetched: true,
      };
    }
    case SHOW_RESULTS: {
      const { show } = action;
      return {
        ...state,
        showResults: show,
      };
    }
    case RESET_SITE_SEARCH: {
      return {
        ...state,
        totalCount: null,
        data: [],
      };
    }

    default:
      return state;
  }
}

export default siteSearchReducer;
